module.exports = __webpack_public_path__ + "static/media/idiom_check.cd1a9934.svg";